import React from 'react';
import './App.css';
import Index from './App/Index';

function App() {
  return (
    <div className="App">
      <Index/>
    </div>
  );
}

export default App;
